// BL598 Phase 2 — `grid describe <noun>` (kubectl-noun pattern).

import { Command } from 'commander';
import { describeGridCommand } from './grid.js';
import { describeEntityCommand } from './entity.js';

export const describeCommand = new Command('describe')
  .description('Show details of a grid or entity')
  .addCommand(describeGridCommand)
  .addCommand(describeEntityCommand);
